import { useHistory } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { Button } from '../../components/common';
import logo from '../../assets/pictures/agrowelogogreen.png';
import colors from '../../assets/colors';
import texts from '../../assets/texts';

export default function AccountActivationInfo() {
  const history = useHistory();
  const handleSubmit = (event) => {
    history.push('/login');
  };

  return (
    <Grid
      container
      spacing={4}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={12}>
        <img src={logo} alt="logo" height={'200vh'} />
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="h4"
          component="h1"
          align="center"
          sx={{ color: colors.oldAgroweGreen }}
        >
          {texts.accountAcitivationLinkSent}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="h4"
          component="h1"
          align="center"
          sx={{ color: colors.oldAgroweGreen }}
        >
          {texts.accountActivationLinkSentInfo}
        </Typography>
      </Grid>
      <Grid item xs={12} justifyContent={'center'}>
        <Button type="submit" variant="contained" onClick={handleSubmit}>
          Przejdź do widoku logowania
        </Button>
      </Grid>
    </Grid>
  );
}
